import { Link } from '@hypothesis/frontend-shared';
import { domainAndTitle } from '../helpers/annotation-metadata';
import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/**
 * Render some metadata about an annotation's document and link to it
 * if a link is available.
 */
export default function AnnotationDocumentInfo(_ref) {
  var _annotation$links;
  var annotation = _ref.annotation;
  var _domainAndTitle = domainAndTitle(annotation),
    domain = _domainAndTitle.domain,
    title = _domainAndTitle.titleText,
    titleLink = _domainAndTitle.titleLink;
  var annotationURL = ((_annotation$links = annotation.links) === null || _annotation$links === void 0 ? void 0 : _annotation$links.html) || '';
  // There are some cases at present in which linking directly to an
  // annotation's document is not immediately feasible—e.g in an LMS context
  // where the original document might not be available outside of an
  // assignment (e.g. Canvas files), and/or wouldn't be able to present
  // any associated annotations.
  // For the present, disable links to annotation documents for all third-party
  // annotations until we have a more nuanced way of making linking determinations.
  // The absence of a link to a single-annotation view is a signal that this
  // is a third-party annotation.
  // Also, of course, verify that there is a URL to the document (titleLink)
  var link = annotationURL && titleLink ? titleLink : '';
  return _jsxs("div", {
    className: "flex gap-x-1",
    children: [_jsxs("div", {
      className: "text-color-text-light",
      children: ["on \"", link ? _jsx(Link, {
        href: link,
        target: "_blank",
        underline: "none",
        children: title
      }) : _jsx("span", {
        children: title
      }), "\""]
    }), domain && _jsxs("span", {
      className: "text-color-text-light",
      children: ["(", domain, ")"]
    })]
  });
}
//# sourceMappingURL=AnnotationDocumentInfo.js.map